import level2 from 'src/data/floorplates/svg/level2';
import level3 from 'src/data/floorplates/svg/level3';
import level4 from 'src/data/floorplates/svg/level4';
import level5 from 'src/data/floorplates/svg/level5';
import level6to13 from 'src/data/floorplates/svg/level6-13';
import level14 from 'src/data/floorplates/svg/level14';
import level15to18 from 'src/data/floorplates/svg/level15-18';
import level19 from 'src/data/floorplates/svg/level19';
import level20to32 from 'src/data/floorplates/svg/level20-32';

const levels = [
  level2,
  level3,
  level4,
  level5,
  level6to13,
  level14,
  level15to18,
  level19,
  level20to32,
];

export default levels;



// WEBPACK FOOTER //
// ./src/data/floorplates/levels.js